/* unplugin-vue-components disabled */import { render } from "./file-picker.vue?vue&type=template&id=2508b87f"
import script from "./file-picker.vue?vue&type=script&lang=js"
export * from "./file-picker.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/controls/file-picker.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2508b87f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2508b87f', __exports__)) {
    api.reload('2508b87f', __exports__)
  }
  
  module.hot.accept("./file-picker.vue?vue&type=template&id=2508b87f", () => {
    api.rerender('2508b87f', render)
  })

}


export default __exports__